<template>
  <b-form>
    <div class="row mb-3">
      <div class="col-md-6 d-flex align-items-center">
        <span class="fw-bold">SPTJM</span>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div>
            <small>Format file: PDF, Ukuran maksimal: 5MB <span class="text-danger">*</span></small>
          </div>
          <div class="col-6">
            <b-form-file
              v-model="form.file_sptjm"
              id="file_sptjm"
              plain
              class="form-control"
              name="SPTJM"
              accept=".pdf"
              @change="checkFileSize($event, 'file_sptjm')"
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-6 d-flex">
            <a :class="{ 'btn btn-success': true, disabled: !id_file_sptjm }" @click="unduhFile(id_file_sptjm)">
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('SPTJM')">
          {{ errors.first('SPTJM') }}
        </span>
        <span class="text-danger" v-if="errors.has('file_sptjm', 'custom')">
          {{ errors.first('file_sptjm', 'custom') }}
        </span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6 d-flex align-items-center">
        <span class="fw-bold">Surat Kuasa</span>
        <a href="#" class="btn btn-secondary ms-2 text-white" @click.prevent>
          <i class="fa fa-eye" />
          Template
        </a>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div>
            <small>Format file: PDF, Ukuran maksimal: 5MB <span class="text-danger">*</span></small>
          </div>
          <div class="col-6">
            <b-form-file
              v-model="form.file_surat_kuasa"
              id="file_surat_kuasa"
              plain
              class="form-control"
              name="Surat Kuasa"
              accept=".pdf"
              @change="checkFileSize($event, 'file_surat_kuasa')"
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-6 d-flex">
            <a
              :class="{ 'btn btn-success': true, disabled: !id_file_surat_kuasa }"
              @click="unduhFile(id_file_surat_kuasa)"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Surat Kuasa')">
          {{ errors.first('Surat Kuasa') }}
        </span>
        <span class="text-danger" v-if="errors.has('file_surat_kuasa', 'custom')">
          {{ errors.first('file_surat_kuasa', 'custom') }}
        </span>
      </div>
    </div>
    <div class="border-bottom mb-3" style="--bs-border-color: black"></div>

    <legend class="text-black fw-bold">Identitas Pemegang Persetujuan/Konfirmasi</legend>
    <div :class="['row mb-5', { 'pe-none opacity-75': !sudah_upload_surat_pengantar }]">
      <div class="col-md-6">
        <label>Jenis Kegiatan <span class="text-danger">*</span></label>
        <v-select
          v-model="form.jenis_kegiatan"
          id="tahun_laporan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionJenisKegiatan"
          name="Jenis Kegiatan"
          v-validate="'required'"
          @input="selectJenisKegiatan"
          :class="{ 'pe-none': is_selesai }"
        />
        <span class="text-danger" v-if="errors.has('Jenis Kegiatan')">
          {{ errors.first('Jenis Kegiatan') }}
        </span>
      </div>
      <div class="col-md-6">
        <label>Nomor KKPRL/Nomor OSS <span class="text-danger">*</span></label>
        <i
          class="fa fa-info-circle ml-1"
          v-b-tooltip.hover.topright="
            'Mohon input secara manual apabila Nomor KKPRL/OSS belum tersedia di dalam sistem'
          "
        />
        <div ref="dropdownNomorKkprl">
          <b-form-input
            v-model="form.nomor_kkprl"
            id="nomor_kkprl"
            v-validate="'required'"
            name="Nomor KKPRL"
            :class="{ input: true, 'is-danger': errors.has('Nomor KKPRL') }"
            :disabled="is_selesai"
            autocomplete="off"
            style="background-color: white"
            @click="toggleOptionKkprl(true)"
          ></b-form-input>
          <div v-if="showOptionKkprl" style="position: relative">
            <div class="option-kkprl-container">
              <div
                v-for="d in filteredNomorKkprl"
                class="option-kkprl-item"
                @click="
                  d.includes('Tidak ada pilihan') || d.includes('Pilih Jenis Kegiatan') ? undefined : selectKkprl(d)
                "
              >
                {{ d }}
              </div>
            </div>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Nomor KKPRL')">
          {{ errors.first('Nomor KKPRL') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tahun Laporan <span class="text-danger">*</span></label>
        <i
          class="fa fa-info-circle ml-1"
          v-b-tooltip.hover.topright="'Hanya menampilkan tahun yang belum dilakukan pelaporan tahunan'"
        />
        <v-select
          v-model="form.tahun_laporan"
          id="tahun_laporan"
          :options="filteredTahun"
          name="Tahun Laporan"
          v-validate="'required'"
          @input="checkLaporanIsAvailable"
          :class="{ 'pe-none': is_selesai }"
        />
        <span class="text-danger" v-if="errors.has('Tahun Laporan')">
          {{ errors.first('Tahun Laporan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tanggal Penerbitan KKPRL <span class="text-danger">*</span></label>
        <DatePicker
          id="tgl_penerbitan"
          lang="en"
          :placeholder="tgl_penerbitan"
          input-class="form-control"
          @change="
            (val) => {
              this.tgl_penerbitan = val.toLocaleDateString('en-GB')
              this.form.tanggal_penerbitan = formatDate(val, 'YYYY-MM-DD')
              this.errors.remove('Tanggal Penerbitan')
            }
          "
          :class="['w-100', { 'pe-none': is_selesai }]"
        >
          <i class="fa fa-calendar-o" slot="calendar-icon" />
        </DatePicker>
        <span class="text-danger" v-if="errors.has('Tanggal Penerbitan')">
          {{ errors.first('Tanggal Penerbitan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nama Pemegang (Sesuai dengan KKPRL Terbit) <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nama_pemegang"
          id="nama_pemegang"
          v-validate="'required'"
          name="Nama Pemegang"
          :disabled="is_selesai"
          :class="{
            input: true,
            'is-danger': errors.has('Nama Pemegang'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Pemegang')">
          {{ errors.first('Nama Pemegang') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Pokok Wajib Pajak <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.npwp"
          id="npwp"
          v-mask="'##.###.###.#-###.####'"
          v-validate="'required'"
          name="NPWP"
          :disabled="is_selesai"
          :class="{ input: true, 'is-danger': errors.has('NPWP') }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('NPWP')">
          {{ errors.first('NPWP') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Alamat Kantor <span class="text-danger">*</span></label>
        <b-form-textarea
          name="Alamat Kantor"
          v-validate="'required'"
          v-model="form.alamat_kantor"
          id="alamat_kantor"
          rows="3"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-textarea>
        <span class="text-danger" v-if="errors.has('Alamat Kantor')">
          {{ errors.first('Alamat Kantor') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon/Faksimil <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.no_telepon"
          id="no_telepon"
          v-mask="'#############'"
          v-validate="'required'"
          name="No Telepon"
          :class="{
            input: true,
            'is-danger': errors.has('No Telepon'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('No Telepon')">
          {{ errors.first('No Telepon') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.email"
          id="email"
          v-validate="'required|email'"
          name="Surat Elektronik"
          :class="{
            input: true,
            'is-danger': errors.has('Surat Elektronik'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Surat Elektronik')">
          {{ errors.first('Surat Elektronik') }}
        </span>
        <span class="text-danger" v-if="errors.has('email_validation') && !errors.has('Surat Elektronik')">
          {{ errors.first('email_validation') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Status Penanaman Modal <span class="text-danger">*</span></label>
        <v-select
          v-model="form.status_penanaman_modal"
          id="status_penanaman_modal"
          :reduce="(data) => data.value"
          label="text"
          :options="optionStatusPenanamanModal"
          name="Status Penanaman"
          v-validate="'required'"
          :class="{ 'pe-none': is_selesai }"
        />
        <b-form-input
          v-if="form.status_penanaman_modal === 'Lainnya'"
          v-model="form.status_penanaman_modal_lainnya"
          id="status_penanaman_modal_lainya"
          v-validate="'required'"
          name="Status Penanaman"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Status Penanaman')">
          {{ errors.first('Status Penanaman') }}
        </span>
      </div>
    </div>

    <legend class="text-black fw-bold">Identitas Penanggung Jawab</legend>
    <div :class="['row', { 'pe-none opacity-75': !sudah_upload_surat_pengantar }, { 'pe-none': is_selesai }]">
      <div class="col-md-6">
        <label>Nama Penanggung Jawab <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nama_penanggungjawab"
          id="nama_penanggungjawab"
          v-validate="'required'"
          name="Nama Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Nama Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Penanggung Jawab')">
          {{ errors.first('Nama Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6">
        <label>Jabatan Penanggung Jawab <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.jabatan_penanggungjawab"
          id="jabatan_penanggungjawab"
          v-validate="'required'"
          name="Jabatan Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Jabatan Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Jabatan Penanggung Jawab')">
          {{ errors.first('Jabatan Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon Seluler <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.no_hp_penanggungjawab"
          id="no_hp_penanggungjawab"
          v-mask="'#############'"
          v-validate="'required'"
          name="No Telepon Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('No Telepon Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('No Telepon Penanggung Jawab')">
          {{ errors.first('No Telepon Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.email_penanggungjawab"
          id="email_penanggungjawab"
          v-validate="'required|email'"
          name="Surat Elektronik Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Surat Elektronik Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Surat Elektronik Penanggung Jawab')">
          {{ errors.first('Surat Elektronik Penanggung Jawab') }}
        </span>
        <span
          class="text-danger"
          v-if="errors.has('email_validation2') && !errors.has('Surat Elektronik Penanggung Jawab')"
        >
          {{ errors.first('email_validation2') }}
        </span>
      </div>
    </div>

    <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../../helper/helpernew'
import Swal from 'sweetalert2'
import { telpMask } from '../../../helper/validationHelper'
import api from '@/services/api'
import { isReadonlyStatus } from './statusRencanaAksi'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      no_oss: null,
      form: {
        file_sptjm: null,
        file_surat_kuasa: null,
        nomor_kkprl: '',
        jenis_kegiatan: '',
        tahun_laporan: '',
        tanggal_penerbitan: null,
        nama_pemegang: '',
        npwp: '',
        alamat_kantor: '',
        no_telepon: '',
        email: '',
        status_penanaman_modal: '',
        status_penanaman_modal_lainnya: '',
        nama_penanggungjawab: '',
        jabatan_penanggungjawab: '',
        no_hp_penanggungjawab: '',
        email_penanggungjawab: '',
      },
      showOptionKkprl: false,
      dataPerizinan: [],
      dataNomorKkprl: [],
      listLaporanExist: [],
      dataLaporan: null,
      is_selesai: false,
      sudah_upload_surat_pengantar: false,
      id_file_sptjm: null,
      id_file_surat_kuasa: null,
      tgl_penerbitan: 'dd/mm/yyyy',
      optionTahunLaporan: [],
      // prettier-ignore
      optionStatusPenanamanModal: [
        { value: 'Penanaman Modal Dalam Negeri (PMDN)', text: 'Penanaman Modal Dalam Negeri (PMDN)', },
        { value: 'Penanaman Modal Asing (PMA)', text: 'Penanaman Modal Asing (PMA)', },
        { value: 'Lainnya', text: 'Lainnya', },
        { value: 'Tidak Ada', text: 'Tidak Ada', },
      ],
      // prettier-ignore
      optionJenisKegiatan: [
        { value: 'Berusaha', text: 'Berusaha', },
        { value: 'Non Berusaha', text: 'Non Berusaha', },
      ],
    }
  },
  inject: ['inj_is_selesai', 'setIsSelesai', 'inj_data_laporan', 'setDataLaporan'],
  async mounted() {
    document.addEventListener('click', this.handleClickOutside)
    await this.loadPersiapanPenilaian()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    telpMask,
    formatDate,

    handleClickOutside(e) {
      const dropdown = this.$refs.dropdownNomorKkprl
      if (!dropdown) return
      if (!dropdown.contains(e.target)) {
        this.toggleOptionKkprl(false)
      }
    },

    buildFormData() {
      const formData = new FormData()

      if (this.form.file_sptjm) {
        formData.append('file_sptjm', this.form.file_sptjm)
      } else if (this.id_file_sptjm) {
        formData.append('id_file_sptjm', this.id_file_sptjm)
      }
      if (this.form.file_surat_kuasa) {
        formData.append('file_surat_kuasa', this.form.file_surat_kuasa)
      } else if (this.id_file_surat_kuasa) {
        formData.append('id_file_surat_kuasa', this.id_file_surat_kuasa)
      }
      formData.append('id_rencana_aksi', this.$route.query.id_rencana_aksi || '')
      formData.append('nomor_kkprl', (this.form.nomor_kkprl || '').replaceAll(' ', ''))
      formData.append('jenis_kegiatan', this.form.jenis_kegiatan)
      formData.append('tahun_laporan', this.form.tahun_laporan)
      formData.append('tanggal_penerbitan', this.form.tanggal_penerbitan || '')
      formData.append('nama_pemegang', this.form.nama_pemegang)
      formData.append('npwp', this.form.npwp)
      formData.append('alamat_kantor', this.form.alamat_kantor)
      formData.append('no_telepon', this.form.no_telepon)
      formData.append('email', this.form.email)
      formData.append('status_penanaman_modal', this.form.status_penanaman_modal)
      formData.append('status_penanaman_modal_lainnya', this.form.status_penanaman_modal_lainnya || '')
      formData.append('nama_penanggungjawab', this.form.nama_penanggungjawab)
      formData.append('jabatan_penanggungjawab', this.form.jabatan_penanggungjawab)
      formData.append('no_hp_penanggungjawab', this.form.no_hp_penanggungjawab)
      formData.append('email_penanggungjawab', this.form.email_penanggungjawab)

      return formData
    },

    async nextForm() {
      if (this.is_selesai) return true

      if (!this.form.tanggal_penerbitan) {
        this.errors.add({
          field: 'Tanggal Penerbitan',
          msg: 'Tanggal Penerbitan wajib diisi',
        })
      }

      if (!this.form.file_sptjm && !this.id_file_sptjm) {
        this.errors.add({
          field: 'SPTJM',
          msg: 'SPTJM wajib diunggah',
        })
      }

      if (!this.form.file_surat_kuasa && !this.id_file_surat_kuasa) {
        this.errors.add({
          field: 'Surat Kuasa',
          msg: 'Surat Kuasa wajib diunggah',
        })
      }

      if (!(await this.$validator.validateAll()) || this.errors.any()) {
        return false
      }

      const idPersiapanPenilaian = this.$route.query.id_persiapan_penilaian
      const url = idPersiapanPenilaian ? `api/persiapan_penilaian/${idPersiapanPenilaian}` : `api/persiapan_penilaian`

      this.$loading(true)
      try {
        const res = await api.post(url, this.buildFormData())

        if (res.data?.data?.id_file_sptjm) {
          this.id_file_sptjm = res.data.data.id_file_sptjm
          this.form.file_sptjm = null
        }

        if (res.data?.data?.id_file_surat_kuasa) {
          this.id_file_surat_kuasa = res.data.data.id_file_surat_kuasa
          this.form.file_surat_kuasa = null
        }

        if (!idPersiapanPenilaian && res.data?.data?.id) {
          await this.$router
            .replace({
              path: this.$route.path,
              query: { ...this.$route.query, id_persiapan_penilaian: res.data.data.id },
            })
            .catch(() => {})
        }

        Swal.fire('Berhasil', 'Identitas penilaian pelaksanaan tersimpan', 'success')
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.$loading(false)
      }
    },

    applyStatusPenanamanModal(data) {
      const status = data.status_penanaman_modal
      const isOption = this.optionStatusPenanamanModal.some((option) => option.value === status)

      if (status && !isOption) {
        this.form.status_penanaman_modal = 'Lainnya'
        this.form.status_penanaman_modal_lainnya = data.status_penanaman_modal_lainnya || status
      } else {
        this.form.status_penanaman_modal = status || ''
        this.form.status_penanaman_modal_lainnya = data.status_penanaman_modal_lainnya || ''
      }
    },

    async loadPersiapanPenilaian() {
      const id_rencana_aksi = this.$route.query.id_rencana_aksi
      let dataPersiapanPenilaian = null
      if (id_rencana_aksi) {
        const resPersiapanPenilaian = await api.get(
          `api/persiapan_penilaian?filter=id_rencana_aksi,=,${id_rencana_aksi}`,
        )
        dataPersiapanPenilaian = resPersiapanPenilaian.data?.data[0]
        if (!dataPersiapanPenilaian) {
          await this.loadLaporanTahunan()
          return
        }
      }

      const id_persiapan_penilaian = dataPersiapanPenilaian.id
      if (!id_persiapan_penilaian) return
      await this.$router
        .replace({
          path: this.$route.path,
          query: { ...this.$route.query, id_persiapan_penilaian: id_persiapan_penilaian },
        })
        .catch(() => {})

      this.$loading(true)
      try {
        const res = await api.get(`api/persiapan_penilaian/${id_persiapan_penilaian}`)
        const data = res.data?.data
        if (!data) return

        this.sudah_upload_surat_pengantar = true

        this.is_selesai = isReadonlyStatus(data.status)
        this.setIsSelesai(this.is_selesai)

        Object.assign(this.form, {
          nomor_kkprl: data.nomor_kkprl || '',
          jenis_kegiatan: data.jenis_kegiatan || '',
          tahun_laporan: data.tahun_laporan ? String(data.tahun_laporan) : '',
          tanggal_penerbitan: data.tanggal_penerbitan || null,
          nama_pemegang: data.nama_pemegang || this.user.nama || '',
          npwp: data.npwp || this.user.npwp || '',
          alamat_kantor: data.alamat_kantor || '',
          no_telepon: data.no_telepon || '',
          email: data.email || this.user.email || '',
          nama_penanggungjawab: data.nama_penanggungjawab || '',
          jabatan_penanggungjawab: data.jabatan_penanggungjawab || '',
          no_hp_penanggungjawab: data.no_hp_penanggungjawab || '',
          email_penanggungjawab: data.email_penanggungjawab || '',
        })

        this.applyStatusPenanamanModal(data)

        this.id_file_sptjm = data.id_file_sptjm || null
        this.id_file_surat_kuasa = data.id_file_surat_kuasa || null

        if (data.tanggal_penerbitan) {
          this.tgl_penerbitan = formatDate(data.tanggal_penerbitan, 'DD/MM/YYYY')
        }
        if (data.jenis_kegiatan) {
          this.getPermohonan()
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Terjadi kesalahan saat mengambil data persiapan penilaian'
        Swal.fire('Gagal', message, 'error')
      } finally {
        this.$loading(false)
      }
    },

    async loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      try {
        const url =
          this.user.role === 'Pemrakarsa'
            ? `api/laporan_tahunan?filter=id_user,=,${this.user.id}&limit=0`
            : `api/laporan_tahunan/${this.$route.query.id_laporan}`
        const res = await api.get(url)
        const resData = this.user.role === 'Pemrakarsa' ? res.data.data : [res.data.data]
        this.listLaporanExist = resData
        const data = resData.find((d) => d.id == this.$route.query.id_laporan)
        if (data) {
          this.sudah_upload_surat_pengantar = true
          this.dataLaporan = data
          this.setDataLaporan(data)

          Object.assign(this.form, {
            nomor_kkprl: data.nomor_kkprl || '',
            tahun_laporan: data.tahun_laporan || '',
            jenis_kegiatan: data.jenis_kegiatan || '',
            tanggal_penerbitan: data.tanggal_penerbitan,
            nama_pemegang: data.nama_pemegang || this.user.nama || '',
            npwp: data.npwp || this.user.npwp || '',
            alamat_kantor: data.alamat_kantor || '',
            no_telepon: data.no_telepon || '',
            email: data.email || this.user.email || '',
            nama_penanggungjawab: data.nama_penanggungjawab || '',
            jabatan_penanggungjawab: data.jabatan_penanggungjawab || '',
            no_hp_penanggungjawab: data.no_hp_penanggungjawab || '',
            email_penanggungjawab: data.email_penanggungjawab || '',
          })
          this.applyStatusPenanamanModal(data)
          this.id_file_sptjm = data.id_file_sptjm || null
          this.id_file_surat_kuasa = data.id_file_surat_kuasa || null
          if (data.tanggal_penerbitan) {
            this.tgl_penerbitan = formatDate(data.tanggal_penerbitan, 'DD/MM/YYYY')
          }
          if (data.jenis_kegiatan) {
            this.getPermohonan()
          }
        }
        // this.getTahunLaporan()
      } catch (error) {
        Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
      } finally {
        this.$loading(false)
      }
    },

    async checkLaporanIsAvailable() {
      if (this.dataLaporan?.tahun_laporan === this.form.tahun_laporan) return
      const res = await api.get(
        `api/laporan_tahunan?filter=id_user,=,${this.user.id};nomor_kkprl,=,${this.form.nomor_kkprl};tahun_laporan,=,${this.form.tahun_laporan};jenis_kegiatan,=,${this.form.jenis_kegiatan}`,
      )
      if (res.data?.data?.length) {
        Swal.fire(`Laporan tahunan tahun ${this.form.tahun_laporan} sudah dilaporkan`, '', 'info').then((res) => {
          this.form.tahun_laporan = ''
        })
      }
    },

    selectJenisKegiatan() {
      this.form.nomor_kkprl = ''
      this.form.nama_pemegang = this.user.nama
      this.form.tanggal_penerbitan = ''
      this.form.npwp = this.user.npwp
      this.form.email = ''
      this.form.alamat_kantor = ''
      this.form.no_telepon = ''
      this.tgl_penerbitan = ''
      this.getPermohonan()
    },

    async getPermohonan() {
      this.$loading(true)
      if (this.form.jenis_kegiatan === 'Berusaha') {
        await api
          .get(`api/ref/getPermohonan/Berusaha?filter=npwp_pemohon,=,${this.user.npwp};keterangan_status,=,Terbit`)
          .then((res) => {
            const data = res.data.data
            this.dataPerizinan = data
            this.dataNomorKkprl = data.length ? data.map((d) => d.nomor_oss) : ['Tidak ada pilihan Nomor KKPRL/OSS']
          })
      } else {
        await api
          .get(`api/ref/getPermohonan/Nonberusaha?filter=npwp_pemohon,=,${this.user.npwp};keterangan_status,=,Terbit`)
          .then((res) => {
            const data = res.data.data
            this.dataPerizinan = data
            this.dataNomorKkprl = data.length ? data.map((d) => d.nomor_kkp) : ['Tidak ada pilihan Nomor KKPRL/OSS']
          })
      }
      this.$loading(false)
    },

    selectKkprl(d) {
      this.form.nomor_kkprl = d

      if (this.form.jenis_kegiatan === 'Berusaha') {
        const data = this.dataPerizinan.find((dd) => dd.nomor_oss === d)
        if (data) {
          this.form.nama_pemegang = data.nama_pemohon
          this.form.tanggal_penerbitan = data.tanggal_terbit_oss
          this.form.npwp = data.npwp_pemohon
          this.form.email = data.email_pemohon
          // this.form.alamat_kantor = ''
          // this.form.no_telepon = ''
          this.tgl_penerbitan = data.tanggal_terbit_oss
            ? formatDate(data.tanggal_terbit_oss, 'DD/MM/YYYY')
            : 'dd/mm/yyyy'
        }
      } else {
        const data = this.dataPerizinan.find((dd) => dd.nomor_kkp === d)
        if (data) {
          this.form.nama_pemegang = data.instansi_pemohon
          this.form.tanggal_penerbitan = data.tanggal_ttd_mkp
          this.form.npwp = data.npwp_pemohon
          this.form.email = data.email_pemohon
          this.form.alamat_kantor = data.alamat_pemohon
          this.form.no_telepon = data.no_hp_pemohon
          this.tgl_penerbitan = data.tanggal_ttd_mkp ? formatDate(data.tanggal_ttd_mkp, 'DD/MM/YYYY') : 'dd/mm/yyyy'
        }
      }

      this.toggleOptionKkprl(false)
    },

    toggleOptionKkprl(val) {
      this.showOptionKkprl = val
    },

    inputNoKkprl() {
      this.form.jenis_kegiatan = ''
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
        e.target.value = null
        this.form[field] = null
      } else {
        this.errors.remove(field, 'custom')
        this.errors.remove('Surat Pengantar')
        if (field === 'file_sptjm') {
          this.errors.remove('SPTJM')
        }
        if (field === 'file_surat_kuasa') {
          this.errors.remove('Surat Kuasa')
        }
        if (file) {
          this.sudah_upload_surat_pengantar = true
        }
      }
    },

    async getTahunLaporan() {
      const existingYear = new Set()
      for (const d of this.listLaporanExist) {
        if (d.tahun_laporan) existingYear.add(parseInt(d.tahun_laporan))
      }
      if (this.dataLaporan?.tahun_laporan) {
        existingYear.delete(parseInt(this.dataLaporan.tahun_laporan))
      }
      const date = new Date()
      const year = date.getFullYear() + 1
      const option = []
      for (let i = year; i > year - 10 - existingYear.size; i--) {
        if (!existingYear.has(i)) {
          option.push(`${i}`)
        }
      }
      this.optionTahunLaporan = option
    },

    async unduhFile(id) {
      if (!(Number(id) > 0)) return
      const res = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },
  },
  computed: {
    filteredNomorKkprl() {
      const filtered = this.dataNomorKkprl.filter((d) => d.includes(this.form.nomor_kkprl))
      if (!this.form.jenis_kegiatan) {
        return ['Pilih Jenis Kegiatan terlebih dahulu']
      }
      return filtered.length ? filtered : ['Tidak ada pilihan Nomor KKPRL/OSS']
    },
    filteredTahun() {
      const existingYear = new Set()
      const filteredLaporan =
        this.form.jenis_kegiatan && this.form.nomor_kkprl
          ? this.listLaporanExist.filter(
              (d) => d.jenis_kegiatan === this.form.jenis_kegiatan && d.nomor_kkprl === this.form.nomor_kkprl,
            )
          : []
      for (const d of filteredLaporan) {
        if (d.tahun_laporan) existingYear.add(parseInt(d.tahun_laporan))
      }
      if (this.dataLaporan?.tahun_laporan) {
        existingYear.delete(parseInt(this.dataLaporan.tahun_laporan))
      }
      const date = new Date()
      const year = date.getFullYear() + 1
      const option = []
      for (let i = year; i > year - 10 - existingYear.size; i--) {
        if (!existingYear.has(i)) {
          option.push(`${i}`)
        }
      }
      return option
    },
  },
}
</script>

<style scope>
.option-kkprl-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: white;
  z-index: 10;
  border-radius: 5px;
  border: 1px solid #aaaaaa;
  overflow-y: auto;
  scrollbar-width: thin;
  max-height: 200px;
}

.option-kkprl-item {
  cursor: pointer;
  padding: 5px 10px;
}

.option-kkprl-item:hover {
  background: #dddddd;
}
</style>
